export default "__VITE_ASSET__064a1d90__"